"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOverlayComponents = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("./");
const Sidebar_1 = require("../molecules/Sidebar");
const SidebarMotion_1 = require("../molecules/SidebarMotion");
const organisms_1 = require("../organisms");
const selectors_1 = require("../selectors");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const selectSpecificDetails = (0, selectors_1.createPropertiesSelector)(selectors_1.selectDetails, 'names');
function useOverlayComponents({ tabType, props, isFullScreen, }) {
    const infoBoxDetails = (0, hooks_1.useSelector)(selectSpecificDetails);
    const { names } = infoBoxDetails || {};
    const isSidebarComponent = (0, react_1.useMemo)(() => {
        switch (tabType) {
            case bridge_schema_1.InfoBoxTabType.Motion:
                return true;
            case bridge_schema_1.InfoBoxTabType.Isolate:
                return false;
            default:
                return true;
        }
    }, [tabType]);
    return (0, react_1.useMemo)(() => {
        var _a, _b;
        switch (tabType) {
            case bridge_schema_1.InfoBoxTabType.Motion:
                return {
                    SidebarComponent: props ? ((0, jsx_runtime_1.jsx)(SidebarContainer, { "data-e2e": 'useOverlayComponents_SidebarContainer', children: (0, jsx_runtime_1.jsx)(SidebarMotion_1.SidebarMotion, Object.assign({}, props === null || props === void 0 ? void 0 : props.sidebar, { "data-e2e": 'useOverlayComponents_SidebarMotion' })) })) : null,
                    MotionControl: !isFullScreen && ((0, jsx_runtime_1.jsx)(MotionControlContainer, { "data-e2e": 'useOverlayComponents_MotionControlContainer', children: (0, jsx_runtime_1.jsx)(organisms_1.MotionPanelControl, { "data-e2e": 'useOverlayComponents_MotionPanelControl' }) })),
                    isSidebarComponent,
                    title: (_a = props === null || props === void 0 ? void 0 : props.sidebar.selectedPart) === null || _a === void 0 ? void 0 : _a.title,
                };
            case bridge_schema_1.InfoBoxTabType.Isolate:
                return {
                    SidebarComponent: null,
                    MotionControl: null,
                    isSidebarComponent,
                    title: `Isolate: ${names === null || names === void 0 ? void 0 : names.title} Anterior`,
                };
            default:
                return {
                    SidebarComponent: props ? ((0, jsx_runtime_1.jsx)(SidebarContainer, { "data-e2e": 'useOverlayComponents_SidebarContainer', children: (0, jsx_runtime_1.jsx)(Sidebar_1.Sidebar, Object.assign({}, props === null || props === void 0 ? void 0 : props.sidebar, { "data-e2e": 'useOverlayComponents_Sidebar' })) })) : null,
                    MotionControl: null,
                    isSidebarComponent,
                    title: (_b = props === null || props === void 0 ? void 0 : props.sidebar.selectedPart) === null || _b === void 0 ? void 0 : _b.title,
                };
        }
    }, [tabType, props, isFullScreen, isSidebarComponent, names === null || names === void 0 ? void 0 : names.title]);
}
exports.useOverlayComponents = useOverlayComponents;
const SidebarContainer = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 10px;
  padding: 10px;
  align-items: center;
`;
const MotionControlContainer = styled_components_1.default.div `
  position: absolute;
  display: flex;
  flex-direction: row;
  bottom: 8px;
  left: 16px;

  gap: 10px;
  pointer-events: all;

  ${ui_1.device.mobileS `
    left: 8px;
    right: 8px;
    box-sizing: border-box;
  `}
`;
